export default "__VITE_ASSET__C1vBrJ1x__"